import React from "react";

import styles from "./layout.module.scss";

type MailToLinkProps = {
	link: string;
	text: string;
};

export const MailToLink = ({ link = "", text = "" }: MailToLinkProps) => {
	return (
		<a className={styles.mailtoLink} href={`mailto:${link}`}>
			{text}
		</a>
	);
};
